import React from "react";
import { Link } from "react-router-dom";

const Cancellation = () => {
  return (
    <>
      <section className="section pricing__v2 cu_mtpd" id="pricing">
        <div className="container">
          <div className="row mb-5">
            <div className="col-md-5 mx-auto text-center">
              <span
                className="subtitle text-uppercase mb-3"
                data-aos="fade-up"
                data-aos-delay={0}
              >
                Policies
              </span>
              <h2 className="mb-3 text-[32px]" data-aos="fade-up" data-aos-delay={100}>
                Cancellation Policy
              </h2>
              <p data-aos="fade-up" data-aos-delay={200}>
                Flexible Plans Backed by Clear and Customer-Friendly Cancellation Terms
              </p>
            </div>
          </div>

          <div className="row">
            <div className="col-md-12 mb-4 mb-md-0" data-aos="fade-up" data-aos-delay={300}>
              <ul>
                <li>
                  1.	<strong>Seven-Day Free Look: </strong> Annual plans may be cancelled for a full refund within Seven days of plan purchase, provided no services or wallet credits have been used.
                </li>
                <li>
                  2.	<strong>General Cancellations: </strong> Requests are considered within 7 days of the order. No cancellations apply once vendors have initiated shipping/service.
                </li>
                <li>
                  3.	<strong>Deficiency Refunds: </strong> Refunds/replacements are granted if quality of service is proven poor. Issues must be reported within 7 days of receipt.
                </li>
                <li>
                  4.	<strong>Processing: </strong> Approved refunds are processed within 45-60 days
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Cancellation;
